import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthenticationService } from '../../lib/services/authentication.service';

class MyDialogComponent {
}

class DialogData {
  email: string = undefined;
}

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {

  public resetPasswordForm: UntypedFormGroup;

  constructor(private authenticationService: AuthenticationService,
              private dialogRef: MatDialogRef<MyDialogComponent>,
              private snackbar: MatSnackBar,
              @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit() {
    this.resetPasswordForm = new UntypedFormGroup({
      email: new UntypedFormControl(this.data ? this.data.email : undefined, Validators.compose([Validators.required, Validators.email])),
    });
  }

  onSubmit() {
    if (this.resetPasswordForm.invalid) {
      return;
    }

    this.authenticationService.requestResetPassword(this.resetPasswordForm.get('email').value).subscribe(() => {
      this.dialogRef.close();
      this.snackbar.open('Un email a été envoyé à ' + this.resetPasswordForm.get('email').value + '.', undefined, {
        panelClass: ['success-snackbar'],
        duration: 2500,
      });
    }, error => {
    });
  }
}
